<div class="flex min-h-screen bg-amber-400">
  <!-- Left side - Image/Banner -->
  <div
    class="hidden md:flex md:w-1/2 bg-cover bg-center relative"
    [style.backgroundImage]="'url(assets/repartidor.png)'"
  >
    <div
      class="absolute inset-0 bg-gray-950/50 flex flex-col justify-end p-12 text-white"
    >
      <h2 class="text-4xl font-bold mb-2">Delivery rápido y seguro</h2>
      <p class="text-xl">Tu comida favorita en minutos</p>
    </div>
  </div>

  <!-- Right side - Register Form -->
  <div
    class="w-full md:w-1/2 flex items-center justify-center p-8 bg-amber-400 relative"
    style="
      background-image: url('assets/patrones/fondo_patron_subito.webp');
      background-size: 200px 200px;
      background-repeat: repeat;
      background-position: center;
    "
  >
    <div class="w-full max-w-2xl bg-white rounded-4xl shadow-lg p-8" #formCard>
      <div class="text-center mb-10">
        <div class="flex justify-center mb-4">
          <a [routerLink]="['/']">
            <figure>
              <img
                src="assets/logo/logo_full.png"
                alt="Logo"
                class="h-20 w-auto"
              />
            </figure>
          </a>
        </div>
        <h1 class="text-2xl font-bold text-gray-800">¡Únete a la comunidad!</h1>
        <p class="text-gray-600 mt-2">
          Comienza a disfrutar de entregas rápidas y seguras
        </p>
      </div>

      <!-- Progress Bar -->
      <div class="relative mb-8">
        <div class="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div class="flex items-center mb-2 sm:mb-0">
            <div
              class="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-amber-500 text-white font-bold"
            >
              1
            </div>
            <div
              class="ml-2 text-xs sm:text-sm font-medium"
              [class.text-amber-500]="currentStep === 1"
              [class.text-gray-500]="currentStep !== 1"
            >
              Datos personales
            </div>
          </div>
          <div
            class="flex-grow mx-2 sm:mx-4 w-full sm:w-auto order-3 sm:order-2"
          >
            <div class="h-1 w-full bg-gray-200 rounded">
              <div
                class="h-1 bg-amber-500 rounded"
                [ngStyle]="{ width: currentStep === 1 ? '50%' : '100%' }"
              ></div>
            </div>
          </div>
          <div class="flex items-center mb-2 sm:mb-0 order-2 sm:order-3">
            <div
              class="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full font-bold"
              [ngClass]="{
                'bg-amber-500 text-white': currentStep === 2,
                'bg-gray-300 text-gray-500': currentStep !== 2
              }"
            >
              2
            </div>
            <div
              class="ml-2 text-xs sm:text-sm font-medium"
              [class.text-amber-500]="currentStep === 2"
              [class.text-gray-500]="currentStep !== 2"
            >
              Cuenta
            </div>
          </div>
        </div>
      </div>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
        class="space-y-6"
      >
        <!-- Step 1: Personal Information -->
        @if (currentStep === 1) {
        <div #step1Panel>
          <!-- Nombre Field -->
          <div class="mb-4">
            <label
              for="nombre"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Nombre</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="nombre"
                formControlName="nombre"
                class="w-full pl-10 pr-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    nombre?.invalid && (nombre?.dirty || nombre?.touched)
                }"
                placeholder="Juan"
              />
            </div>
            @if (nombre?.invalid && (nombre?.dirty || nombre?.touched)) {
            <div class="text-red-500 text-sm mt-1">
              @if (nombre?.errors?.['required']) {
              <div>El nombre es requerido</div>
              } @if (nombre?.errors?.['minlength']) {
              <div>El nombre debe tener al menos 2 caracteres</div>
              } @if (nombre?.errors?.['pattern']) {
              <div>El nombre solo debe contener letras</div>
              }
            </div>
            }
          </div>
          <!-- Apellidos Field -->
          <div class="mb-4">
            <label
              for="apellidos"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Apellidos</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="apellidos"
                formControlName="apellidos"
                class="w-full pl-10 pr-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    apellidos?.invalid &&
                    (apellidos?.dirty || apellidos?.touched)
                }"
                placeholder="Pérez"
              />
            </div>
            @if ( apellidos?.invalid && (apellidos?.dirty || apellidos?.touched)
            ) {
            <div class="text-red-500 text-sm mt-1">
              @if (apellidos?.errors?.['required']) {
              <div>Los apellidos son requeridos</div>
              } @if (apellidos?.errors?.['minlength']) {
              <div>Los apellidos deben tener al menos 2 caracteres</div>
              } @if (apellidos?.errors?.['pattern']) {
              <div>Los apellidos solo deben contener letras</div>
              }
            </div>
            }
          </div>
          <!-- Teléfono Field -->
          <div class="mb-4">
            <label
              for="telefono"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Número de teléfono</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                  />
                </svg>
              </div>
              <input
                type="tel"
                id="telefono"
                formControlName="telefono"
                class="w-full pl-10 pr-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    telefono?.invalid && (telefono?.dirty || telefono?.touched)
                }"
                placeholder="+34612345678"
              />
            </div>
            @if ( telefono?.invalid && (telefono?.dirty || telefono?.touched) )
            {
            <div class="text-red-500 text-sm mt-1">
              @if (telefono?.errors?.['required']) {
              <div>El número de teléfono es requerido</div>
              } @if (telefono?.errors?.['pattern']) {
              <div>Ingresa solo números (máximo 13 dígitos)</div>
              } @if (telefono?.errors?.['maxlength']) {
              <div>El número de teléfono no debe exceder 13 dígitos</div>
              }
            </div>
            }
          </div>
          <!-- Fecha de Nacimiento Field -->
          <div class="mb-4">
            <label
              for="fechaNacimiento"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Fecha de nacimiento</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="date"
                id="fechaNacimiento"
                formControlName="fechaNacimiento"
                class="w-full pl-10 pr-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    fechaNacimiento?.invalid &&
                    (fechaNacimiento?.dirty || fechaNacimiento?.touched)
                }"
                placeholder="dd/mm/aaaa"
              />
            </div>
            @if ( fechaNacimiento?.invalid && (fechaNacimiento?.dirty ||
            fechaNacimiento?.touched) ) {
            <div class="text-red-500 text-sm mt-1">
              @if (fechaNacimiento?.errors?.['required']) {
              <div>La fecha de nacimiento es requerida</div>
              } @if (fechaNacimiento?.errors?.['underage']) {
              <div>Debes ser mayor de 18 años para registrarte</div>
              }
            </div>
            }
          </div>
          <!-- Next Button -->
          <button
            type="button"
            (click)="nextStep()"
            [disabled]="!step1Valid"
            class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="flex items-center">
              Siguiente
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 ml-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </button>
        </div>
        }

        <!-- Step 2: Account Information -->
        @if (currentStep === 2) {
        <div #step2Panel>
          <!-- Email Field -->
          <div class="mb-4">
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Correo electrónico</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                  />
                  <path
                    d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                  />
                </svg>
              </div>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="w-full pl-10 pr-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    email?.invalid && (email?.dirty || email?.touched)
                }"
                placeholder="juan@ejemplo.com"
              />
            </div>
            @if (email?.invalid && (email?.dirty || email?.touched)) {
            <div class="text-red-500 text-sm mt-1">
              @if (email?.errors?.['required']) {
              <div>El email es requerido</div>
              } @if (email?.errors?.['email']) {
              <div>Por favor ingresa un email válido</div>
              }
            </div>
            }
          </div>
          <!-- Password Field -->
          <div class="mb-4">
            <label
              for="password"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Contraseña</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="{{ showPassword() ? 'text' : 'password' }}"
                id="password"
                formControlName="password"
                class="w-full pl-10 pr-12 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                [ngClass]="{
                  'border-red-500':
                    password?.invalid && (password?.dirty || password?.touched)
                }"
                placeholder="••••••••"
              />
              <button
                type="button"
                (click)="toggleShowPassword()"
                class="absolute inset-y-0 right-0 flex items-center px-3 text-amber-500"
                aria-label="Mostrar u ocultar contraseña"
              >
                @if (!showPassword()) {
                <i class="fas fa-eye"></i>
                } @if (showPassword()) {
                <i class="fas fa-eye-slash"></i>
                }
              </button>
            </div>
            @if ( password?.invalid && (password?.dirty || password?.touched) )
            {
            <div class="text-red-500 text-sm mt-1">
              @if (password?.errors?.['required']) {
              <div>La contraseña es requerida</div>
              } @if (password?.errors?.['minlength']) {
              <div>La contraseña debe tener al menos 8 caracteres</div>
              } @if (password?.errors?.['weakPassword']) {
              <div>
                La contraseña debe incluir al menos una mayúscula y un número
              </div>
              }
            </div>
            }
            <p class="text-xs text-gray-500 mt-2">
              La contraseña debe incluir al menos una mayúscula y un número” por
              ejemplo: “La contraseña debe incluir al menos una minúscula,
              mayúscula, número y un carácter ($, @, %, &, otro)
            </p>
          </div>
          <!-- Buttons -->
          <div class="flex space-x-4">
            <button
              type="button"
              (click)="previousStep()"
              class="w-1/3 flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors duration-200"
            >
              <span class="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                Atrás
              </span>
            </button>
            <button
              type="submit"
              [disabled]="registerForm.invalid || isLoading"
              class="w-2/3 flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              @if (!isLoading) {
              <span class="flex items-center"> Crear cuenta </span>
              } @if (isLoading) {
              <span class="flex items-center">
                <svg
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Procesando...
              </span>
              }
            </button>
          </div>
        </div>
        }
      </form>

      <!-- Login Link -->
      <div class="text-center mt-6">
        <p class="text-sm text-gray-600">¿Ya tienes una cuenta?</p>
        <a
          [routerLink]="['/auth/login']"
          class="text-amber-500 hover:text-amber-600 font-medium"
          >Inicia sesión</a
        >
      </div>

      <!-- Footer -->
      <div class="text-center text-xs text-gray-500 mt-10">
        © 2025 Súbito. Todos los derechos reservados.
      </div>
    </div>
  </div>
</div>
